module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_10X_Section1.2f37e6ca.png";